// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1pdgo","col":"CardReaderDesc_col__2sWdB","label":"CardReaderDesc_label__28BCH"};